import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeContextProvider from "./context/theme-context";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useParams,
} from "react-router-dom";
import {HelmetProvider} from "react-helmet-async";
import Giving from "./pages/giving";
import ContentDetail from "./pages/content-detail";
import NotFound from "./pages/not-found";
import Ministries from "./pages/ministries";
import Resources from "./pages/resources";
import OurPriest from "./pages/our-priest";
import ContactUs from "./pages/contact-us";
import Calendar from "./pages/calendar";
import Home from "./pages/home";

const MinistryRedirect = () => {
  const { slug } = useParams();
  if (!slug) {
    return <Navigate to="/not-found" replace />;
  }
  return <Navigate to={`/ministries/${slug}`} replace />;
};

const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        element: <NotFound />,
        path: "/not-found",
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/giving",
        element: <Giving />,
      },
      {
        path: "/ministries",
        element: <Ministries />,
      },
      {
        path:"/resources",
        element: <Resources/>
      },
      {
        path:"/our-priest",
        element: <OurPriest/>
      },
      {
        path:"/contact-us",
        element: <ContactUs/>
      },
      {
        path:"/calendar",
        element: <Calendar/>
      },
      {
        path: "/latest-news/:slug",
        element: <ContentDetail contentCategory="latestNews" />,
      },
      {
        path: "/ministries/:slug",
        element: <ContentDetail contentCategory="ministry" />,
      },
      {
        path: "/:slug",
        element: <MinistryRedirect />,
      },

    ],
  },
]);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeContextProvider>
        <RouterProvider router={router} />
      </ThemeContextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
